module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    staticClass: "box",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "list__header"
  }, [_c('p', {
    staticClass: "list__title"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.getRouteName(_vm.$route)) + "\n\t\t\t\t")])]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticClass: "list__table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.data,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "nazwa"
    }
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "pull-right",
    attrs: {
      "label": "opcje",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'Edit Menu',
              params: {
                id: scope.row.id
              }
            }
          }
        }, [_c('el-button', {
          attrs: {
            "size": "small",
            "title": _vm.$t('edit')
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small",
            "title": _vm.$t('delete')
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.$index, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        })])]
      }
    }])
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f24cf912"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Menus/MenusList.vue
// module id = 810
// module chunks = 0